export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <img src="/logos/beyond-logo-white.svg" alt="Beyond4" />
          <p>Multi-channel marketing operations for teams that need every location, audience, offer, and report to line up before launch day.</p>
        </div>
        <div className="footer-links">
          <a href="/platform">Platform</a>
          <a href="/websites">Websites</a>
          <a href="/channels">Channels</a>
          <a href="/compliance">Compliance</a>
          <a href="/proof">Product proof</a>
          <a href="mailto:info@beyond4.com">info@beyond4.com</a>
        </div>
      </div>
    </footer>
  );
}
